import Treasure from 'td-js-sdk';

// 接続情報
const client = {
    connect: {
        writeKey: process.env.MIX_TREASURE_WRITE_KEY,
        database: process.env.MIX_TREASURE_DATA_DB_USER,
        startInSignedMode: true,
        host: window.location.hostname, // ローカル確認時はコメントアウト
    },
};

// テーブル名
const TABLE_PV = 'site_view';

const treasureData = document.getElementById('treasure_data');
if (treasureData) {
    const pv = JSON.parse(treasureData.dataset.pv);
    const td = new Treasure(client.connect);
    td.set(TABLE_PV, pv);
    td.trackPageview(TABLE_PV);
}
